import sanitizeHtml from 'sanitize-html';
import type { IOptions } from 'sanitize-html';

/** Ürün kategorisi açıklaması (CMS HTML); kart/grid tipografisi CSS ile sabitlenir */
const OPTIONS: IOptions = {
  allowedTags: [
    'p',
    'br',
    'strong',
    'em',
    'b',
    'i',
    'u',
    'a',
    'span',
    'ul',
    'ol',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
    span: ['class'],
    p: ['class'],
    h1: ['class'],
    h2: ['class'],
    h3: ['class'],
    h4: ['class'],
    h5: ['class'],
    h6: ['class'],
    strong: ['class'],
    b: ['class'],
    em: ['class'],
    i: ['class'],
    u: ['class'],
    li: ['class'],
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
};

/** Açıklama metninin en başındaki tek bir h1–h6 bloğunu (içerik dahil) kaldırır — kart başlığıyla çiftlenen editör başlığı için */
function removeLeadingHeadingBlock(html: string): string {
  let s = html.trimStart();
  const re = /^<h[1-6][^>]*>[\s\S]*?<\/h[1-6]\s*>/i;
  const m = s.match(re);
  if (!m) return html;
  s = s.slice(m[0].length).trimStart();
  s = s.replace(/^(<br\s*\/?>\s*)+/i, '');
  return s;
}

const TOUR_CAT_GRID_SECOND_PASS: IOptions = {
  ...OPTIONS,
  transformTags: {
    h1: sanitizeHtml.simpleTransform('p', {}, false),
    h2: sanitizeHtml.simpleTransform('p', {}, false),
    h3: sanitizeHtml.simpleTransform('p', {}, false),
    h4: sanitizeHtml.simpleTransform('p', {}, false),
    h5: sanitizeHtml.simpleTransform('p', {}, false),
    h6: sanitizeHtml.simpleTransform('p', {}, false),
  },
};

export function sanitizeCategoryDescriptionHtml(raw: string | null | undefined): string {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  return sanitizeHtml(s, OPTIONS);
}

/** TourCatGrid: baştaki h etiketi satırını kaldırır, kalan h1–h6 → p (başlık görünümü yok) */
export function sanitizeTourCatGridDescriptionHtml(raw: string | null | undefined): string {
  let html = sanitizeCategoryDescriptionHtml(raw);
  if (!html) return '';
  html = removeLeadingHeadingBlock(html);
  return sanitizeHtml(html, TOUR_CAT_GRID_SECOND_PASS);
}
